import React from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checked from '../icons/Checked';
import Dotted from '../icons/Dotted';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      paddingTop: 0,
      paddingLeft: 3,
    },
    item: {
      padding: '0px 2px 0px 0px',
      margin: 0,
      '& div:first-child': {
        minWidth: 20,
      },
    },
    listText: {
      padding: 1,
      margin: 1,
      '& span': {
        [theme.breakpoints.down('sm')]: {
          fontSize: 11,
        },
        [theme.breakpoints.up('md')]: {
          fontSize: 13,
        },
      },
    },
  }),
);

const SimpleList: React.FC<any> = ({
  items = [
    {
      checkedWidth: 15,
      checkedHeight: 15,
    },
  ],
  checked,
  checkedWidth,
  checkedHeight,
  color,
  withoutListDecorator = false,
}) => {
  const classes = useStyles();
  return (
    <List component="nav" className={classes.root}>
      {items.map((item: any) => (
        <ListItem key={item.id || item.title} className={classes.item}>
          <ListItemIcon className={classes.item}>
            {!withoutListDecorator &&
              (checked ? (
                <Checked width={checkedWidth} height={checkedHeight} color={color} />
              ) : (
                <Dotted width={checkedWidth} height={checkedHeight} color={color} />
              ))}
          </ListItemIcon>

          <ListItemText primary={item.title} className={classes.listText} />
        </ListItem>
      ))}
    </List>
  );
};

export default SimpleList;
